<div class="container">
  <div class="row black-link">
    <div class="col-md-8 col-lg-8 col-sm-8 text-center mx-auto">
      <div>
        <img
          src="/assets/images/all_complete.png"
          alt="All Complete!"
          style="max-width: 100%"
          class="mb-4"
          />
        <h5>
          Your application is in review.<sup>**</sup>
        </h5>
        <!-- <p class="mt-2">
        The $25 bonus has been applied to your account! After you
        receive your tablet and earn 50 points driving with the
        device you will receive the bonus.
      </p> -->
    </div>

    <div class="text-start row">
      <div class="col-sm-12 complete-info-row">
        <img
          src="/assets/images/send_email.png"
          alt="Email Address"
          class="mb-4 complete-icons"
          />

        <p>
          Email:
          <span class="bold-text">{{ this.user?.email }}</span>
        </p>
      </div>

      <div class="col-sm-12 complete-info-row">
        <img
          src="/assets/images/shipping_address.png"
          alt="Shipping Address"
          class="mb-4 complete-icons"
          />
        <div class="shipping-address">
          <div class="label">Shipping to:</div>

          @if (!allowShippingMethodChange) {
            @if (isFedExPickup) {
              <label
                >FedEx Pickup Location</label
                >
              }
              @if (!isFedExPickup) {
                <label>Home Address</label>
              }
              <div class="bold-text">
                @if (isFedExPickup) {
                  <div>
                    {{
                    this.user?.shipping_info?.fedex_location
                    ?.location_name
                    }}
                    <br />
                    {{
                    this.user?.shipping_info?.fedex_location
                    ?.address
                    }}
                  </div>
                }
                @if (!isFedExPickup) {
                  <div>
                    {{
                    this.user?.shipping_info
                    .mailing_address_line
                    }}
                    {{
                    this.user?.shipping_info
                    .mailing_address_apartment_suite_no
                    }}
                    {{
                    this.user?.shipping_info
                    .mailing_address_city
                    }}
                    {{
                    this.user?.shipping_info
                    .mailing_address_state
                    }}
                    {{
                    this.user?.shipping_info
                    .mailing_address_country
                    }}
                    {{
                    this.user?.shipping_info
                    .mailing_address_zip
                    }}
                  </div>
                }
              </div>
            }

            @if (!allowShippingMethodChange) {
              <div
                class="action-buttons"
                >
                @if (!this.loading) {
                  <button
                    type="button"
                    class="btn-edit"
                    id="complete-update-shipping-address-button"
                    (click)="onShippingChange()"
                    >
                    Update shipping method/address
                  </button>
                }
              </div>
            }

            @if (allowShippingMethodChange) {
              <mat-radio-group
                aria-labelledby="ship-to-group-label"
                [(ngModel)]="isFedExPickup"
                (change)="onShippingChange()"
                >
                <mat-radio-button
                  class="ship-to-option-button"
                  [value]="false"
                  id="complete-permanent-address-radio"
                  >
                  Permanent Address
                  <div class="bold-text">
                    {{
                    this.user?.shipping_info
                    .mailing_address_line
                    }}
                    {{
                    this.user?.shipping_info
                    .mailing_address_apartment_suite_no
                    }}
                    {{
                    this.user?.shipping_info
                    .mailing_address_city
                    }}
                    {{
                    this.user?.shipping_info
                    .mailing_address_state
                    }}
                    {{
                    this.user?.shipping_info
                    .mailing_address_country
                    }}
                    {{
                    this.user?.shipping_info
                    .mailing_address_zip
                    }}
                  </div>
                </mat-radio-button>
                <mat-radio-button
                  class="ship-to-option-button"
                  [value]="true"
                  id="complete-fedex-pickup-radio"
                  >
                  FedEx Pickup Location
                  <div>
                    <div class="bold-text">
                      {{
                      this.user?.shipping_info
                      ?.fedex_location
                      ?.location_name
                      }}
                    </div>
                    <div>
                      {{
                      this.user?.shipping_info
                      ?.fedex_location?.address
                      }}
                    </div>
                    @if (
                      !this.user.shipping_info
                      ?.fedex_location
                      ) {
                      <div
                        class="bold-text"
                        >
                        <small>No location selected</small>
                      </div>
                    }
                  </div>
                </mat-radio-button>
              </mat-radio-group>
            }

            @if (allowShippingMethodChange) {
              <div
                class="action-buttons"
                >
                @if (!this.loading && this.isFedExPickup) {
                  <button
                    type="button"
                    class="btn-edit"
                    id="complete-change-fedex-location-button"
                    (click)="showFedExLocationLookupDialog()"
                    >
                    Change Fedex Location
                  </button>
                }
                @if (
                  !this.loading &&
                  this.isFedExPickup === false &&
                  !isForm
                  ) {
                  <button
                    type="button"
                    class="btn-edit"
                    id="complete-edit-permanent-address-button"
                    (click)="showForm()"
                    >
                    Edit Permanent Address
                  </button>
                }
              </div>
            }
          </div>
        </div>

        @if (isForm) {
          <div class="col-sm-12 complete-info-row">
            <form
              class="form form-wrapper"
              [formGroup]="addressForm"
              autocomplete="off"
              >
              <div class="row">
                <div class="col-lg-8 col-sm-12">
                  <div class="form-group">
                    <label>Street Address*</label>
                    <input
                      type="text"
                      class="form-control"
                      id="complete-shipping-address-input"
                      name="street"
                                        [ngClass]="{
                                            'no-validation': businessError
                                        }"
                      formControlName="address_line"
                                        [octoGooglePlacesAutocomplete]="
                                            octoGooglePlacesAutocomplete
                                        "
                                        (change)="
                                            addressForm.patchValue({
                                                address_line:
                                                    addressForm.value.address_line.toUpperCase()
                                            })
                                        "
                                        (blur)="
                                            addressForm.patchValue({
                                                address_line:
                                                    addressForm.value.address_line.toUpperCase()
                                            })
                                        "
                      />
                    @if ((submitted ) && addressForm.controls.address_line.errors?.['required']) {
                      <p
                        class="error-msg"
                        id="complete-shipping-address-required-error-message"
                        >
                        This field is required
                      </p>
                    }
                    @if (businessError) {
                      <span
                        class="error-msg validationerror"
                        id="complete-shipping-address-business-error-message"
                        >
                        We do not ship to commercial addresses.
                        Please make sure the address is a
                        residential address
                      </span>
                    }
                  </div>
                </div>
                <div class="col-lg-4 col-sm-12">
                  <div class="form-group">
                    <label>Apt/Suite No.</label>
                    <input
                      type="text"
                      name="apartment"
                      class="form-control"
                      id="complete-shipping-address-apartment-input"
                                        [ngClass]="{
                                            'no-validation':
                                                !addressForm.value
                                                    .address_apartment_suite_no
                                        }"
                      formControlName="address_apartment_suite_no"
                                        (change)="
                                            addressForm.patchValue({
                                                address_apartment_suite_no:
                                                    addressForm.value.address_apartment_suite_no.toUpperCase()
                                            })
                                        "
                                        (blur)="
                                            addressForm.patchValue({
                                                address_apartment_suite_no:
                                                    addressForm.value.address_apartment_suite_no.toUpperCase()
                                            })
                                        "
                      />
                    @if (addressForm.controls.address_apartment_suite_no.errors?.['pattern']) {
                      <p
                        class="error-msg"
                        id="complete-shipping-address-apartment-pattern-error-message"
                        >
                        Apt/Suite No. should not contain special
                        character - #
                      </p>
                    }
                  </div>
                </div>
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>City*</label>
                    <input
                      type="text"
                      class="form-control"
                      name="city"
                      formControlName="address_city"
                      id="complete-shipping-address-city-input"
                                        (change)="
                                            addressForm.patchValue({
                                                address_city:
                                                    addressForm.value.address_city.toUpperCase()
                                            })
                                        "
                                        (blur)="
                                            addressForm.patchValue({
                                                address_city:
                                                    addressForm.value.address_city.toUpperCase()
                                            })
                                        "
                      />
                    @if ((submitted ) && addressForm.controls?.['address_city']?.errors?.['required']) {
                      <p
                        class="error validationerror"
                        id="complete-shipping-address-required-error-message"
                        >
                        This field is required
                      </p>
                    }
                  </div>
                </div>
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>
                      {{
                      addressForm.value.address_country.toLowerCase() ===
                      'ca'
                      ? 'Province*'
                      : 'State*'
                      }}</label
                      >
                      <select
                        name="state"
                        class="form-control"
                        formControlName="address_state"
                        id="complete-shipping-address-state-input"
                        >
                        @for (state of states; track state) {
                          <option
                            [value]="state"
                            >
                            {{ state }}
                          </option>
                        }
                      </select>
                      @if ((submitted ) && addressForm.controls.address_state.errors?.['required']) {
                        <p
                          class="error validationerror"
                          id="complete-shipping-address-required-error-message"
                          >
                          This field is required
                        </p>
                      }
                    </div>
                  </div>
                  <div class="col-lg-6 col-sm-12">
                    <div class="form-group">
                      @if (
                        addressForm.value.address_country &&
                        addressForm.value.address_country.toLowerCase() !==
                        'ca'
                        ) {
                        <label
                          >Zip Code*</label
                          >
                        }
                        @if (
                          addressForm.value.address_country &&
                          addressForm.value.address_country.toLowerCase() ===
                          'ca'
                          ) {
                          <label
                            >Postal Code*</label
                            >
                          }
                          <input
                            class="form-control"
                            type="text"
                            formControlName="address_zip"
                            name="zip"
                            id="complete-shipping-address-zip-input"
                            />
                          @if ((submitted ) && addressForm.controls.address_zip.errors?.['required']) {
                            <p
                              class="error"
                              id="complete-shipping-address-pattern-error-message"
                              >
                              Please enter valid zip code
                            </p>
                          }
                        </div>
                      </div>
                      <div class="col-lg-6 col-sm-12">
                        <div class="form-group required">
                          <label
                            class="control-label"
                            for="address_country"
                            >Country*</label
                            >
                            <select
                              class="form-control no-validation"
                              data-default="US"
                              name="country"
                              formControlName="address_country"
                              readonly
                              [attr.disabled]="true"
                              id="complete-shipping-address-country-select"
                              >
                              <option selected value="US">
                                🇺🇸 USA
                              </option>
                              <option value="CA">🇨🇦 Canada</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <p class="text-start">*Required Fields</p>
                      <div class="row text-center">
                        <div>
                          <button
                            [disabled]="submitting || submitted"
                            class="btn btn-save-shipping-address btn-edit"
                            type="submit"
                            id="complete-save-shipping-address-button"
                            (click)="fedexAddressValidation()"
                            >
                            <p class="load-btn small-btn">
                              @if (!submitting && !submitted) {
                                Save
                              }
                              @if (submitting) {
                                <mat-spinner
                                  [diameter]="17"
                                  ></mat-spinner
                                  >Processing
                                }
                                @if (submitted) {
                                  <mat-spinner
                                    [diameter]="17"
                                    ></mat-spinner
                                    >Saving Address
                                  }
                                </p>
                              </button>
                              <input
                                [disabled]="submitting || submitted"
                                type="reset"
                                class="btn btn-cancel address-update"
                                id="complete-cancel-shipping-address-input"
                                value="Cancel"
                                (click)="hideForm()"
                                />
                            </div>
                          </div>
                        </form>
                      </div>
                    }

                    <!-- <div class="col-sm-12 complete-info-row">
                    <img
                      src="/assets/images/partnership.png"
                      alt="Partnership"
                      class="mb-4 complete-icons"
                      />
                    <p>
                      <span class="bold-text">START MAKING 💰💰💰 NOW!</span
                        ><br />
                        Refer other drivers and earn
                        <span *ngIf="country == 'ca'; else usContent">C$25</span
                          ><ng-template #usContent>$25</ng-template> for each
                          driver that activates their tablet using your referral
                          code. You can also copy and paste this link:
                          <br />
                          <span class="tooltip-wrap code-wrap d-inline">
                            <span
                              id="tooltip-copy-code"
                              class="tooltip"
                              [ngClass]="{ show: showCopySuccessMsg }"
                              >Copied!</span
                              >
                              <a
                                class="text-pink copy-text tooltip-text"
                                id="complete-referral-link"
                                [cdkCopyToClipboard]="
                                    env + 'join?referred_by=' + referraLink
                                "
                                (cdkCopyToClipboardCopied)="
                                    copyToClipboard($event)
                                "
                                >
                                {{ env }}join?referred_by={{ referraLink }}</a
                                >
                              </span>
                            </p>
                          </div> -->
                        </div>
                        <hr />
                        <div class="row mb-2">
                          <p class="col-sm-12">
                            <sup>**</sup> If we need any additional information to
                            process your application, we will email you. Otherwise, we
                            will email your FedEx tracking number once the tablet has
                            shipped.
                          </p>
                          <p class="lite-text mt-5 mb-3 mb-5">
                            If you have any questions or concerns, you may reach Octopus
                            by visiting
                            <a href="https://playoctopus.com/help" target="_blank"
                              id="complete-help-link"
                              >playoctopus.com/help
                            </a>
                            or by calling (240) 366-5877 (Monday - Friday).
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
